export default __webpack_public_path__ + "static/media/vretta.7ffe90dd.PNG";